import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import {Alert} from '@mui/lab';
import Loading from '../../Loading';
import TransferCheck from '../Campaign/TransferCheck';

export default function TransferResultDialog({
    resourceType = 'campaign',
    open,
    title,
    selectedList,
    completedTransferList,
    transferResponse,
    env,
    errorAfterCheck,
    setErrorAfterCheck,
    transferInProgress,
    setTransferInProgress,
    onClose
}) {
    const getCompletedItem = id => completedTransferList.find(item => item.campaign === id);

    return <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle textAlign="center">{title(errorAfterCheck)}</DialogTitle>
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500]}}
        >
            <CloseIcon/>
        </IconButton>
        <DialogContent>
            <DialogContentText component="div">
                <Loading isLoading={completedTransferList.length === 0} display="block">
                    <Alert severity="warning">
                        <strong>Do not close the browser and this window until all transfers complete.</strong>
                    </Alert>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b>{resourceType === 'template' ? 'Template' : 'Campaign'}</b></TableCell>
                                <TableCell align="center"><b>In Queue</b></TableCell>
                                <TableCell align="center"><b>Status</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedList.map((item, index) => {
                                const completed = getCompletedItem(item);
                                return <TableRow key={item}>
                                    <TableCell style={{maxWidth: '300px'}}>
                                        {item}
                                        {completed?.error && <Alert severity="error">{completed.error}</Alert>}
                                    </TableCell>
                                    <TableCell>
                                        <Box align="center">
                                            <Loading isLoading={!completed?.hasOwnProperty('transferred')} display="block">
                                                {completed?.transferred ? <DoneIcon/> : <CancelIcon/>}
                                            </Loading>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        {completed?.transferId && <TransferCheck
                                            resourceType={resourceType}
                                            transferInProgress={transferInProgress}
                                            setTransferInProgress={setTransferInProgress}
                                            env={env}
                                            index={index}
                                            setErrorAfterCheck={setErrorAfterCheck}
                                            transferId={completed.transferId}
                                        />}
                                    </TableCell>
                                </TableRow>;
                            })}
                        </TableBody>
                    </Table>
                </Loading>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" disabled={transferResponse.isLoading} onClick={onClose}>Close</Button>
        </DialogActions>
    </Dialog>;
}
